import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef } from 'react';
import style from '../ProductPrice.module.scss.js';

const PriceContainer = forwardRef(({ className, children, isAvailable = true, size = 'default', textAlign, ...otherProps }, ref) => {
    return (jsx("div", { ref: ref, className: classNames(style['z-product-price'], className, {
            [style[`z-product-price--size-${size}`]]: typeof size === 'string',
            [style[`z-product-price--size-all-${typeof size === 'object' && size?.all}`]]: typeof size === 'object' && size?.all,
            [style[`z-product-price--size-xs-${typeof size === 'object' && size?.xs}`]]: typeof size === 'object' && size?.xs,
            [style[`z-product-price--size-sm-${typeof size === 'object' && size?.sm}`]]: typeof size === 'object' && size?.sm,
            [style[`z-product-price--size-md-${typeof size === 'object' && size?.md}`]]: typeof size === 'object' && size?.md,
            [style[`z-product-price--size-lg-${typeof size === 'object' && size?.lg}`]]: typeof size === 'object' && size?.lg,
            [style[`z-product-price--size-xl-${typeof size === 'object' && size?.xl}`]]: typeof size === 'object' && size?.xl,
            [style[`z-product-price--size-xxl-${typeof size === 'object' && size?.xxl}`]]: typeof size === 'object' && size?.xxl,
            [style[`z-product-price--text-align-all-${textAlign?.all}`]]: textAlign?.all,
            [style[`z-product-price--text-align-xs-${textAlign?.xs}`]]: textAlign?.xs,
            [style[`z-product-price--text-align-sm-${textAlign?.sm}`]]: textAlign?.sm,
            [style[`z-product-price--text-align-md-${textAlign?.md}`]]: textAlign?.md,
            [style[`z-product-price--text-align-lg-${textAlign?.lg}`]]: textAlign?.lg,
            [style[`z-product-price--text-align-xl-${textAlign?.xl}`]]: textAlign?.xl,
            [style[`z-product-price--text-align-xxl-${textAlign?.xxl}`]]: textAlign?.xxl,
        }), ...otherProps, "aria-disabled": !isAvailable ? true : undefined, children: children }));
});
PriceContainer.displayName = 'PriceContainer';

export { PriceContainer };
//# sourceMappingURL=PriceContainer.js.map
